import {useContext, useState} from "react";
import {UserContext} from "./UserContext";
import {useTheme} from "./ThemeContext";
import {Link, useNavigate} from "react-router-dom";
import {HashLink} from "react-router-hash-link";

const Navbar = () =>{
    const {userData,setUserData,set_access_token} = useContext(UserContext)
    const {theme, toggleTheme} = useTheme()
    const navigate = useNavigate()
    const [menuOpen,setMenuOpen] = useState(false)

    const LogOut = () =>{
        localStorage.removeItem("access_token")
        setUserData(null)
        set_access_token(null)
        setMenuOpen(false)
        navigate("/")
    }

    const toggleMenu = () => setMenuOpen(prev => !prev)
    const closeMenu = () => setMenuOpen(false)

    return(
        <header className={`site-header ${menuOpen ? "menu-open" : ""}`}>
            <div className="header-inner">
                <Link to={"/"} className="brand-mark" onClick={closeMenu}>
                    <span className="brand-pill">CM</span>
                    <span className="brand-text">Cliff Mutinda</span>
                </Link>

                <button
                    className="menu-toggle"
                    aria-label="Toggle navigation"
                    aria-expanded={menuOpen}
                    onClick={toggleMenu}
                >
                    <span className="menu-bar"/>
                    <span className="menu-bar"/>
                </button>

                <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
                    <HashLink smooth to={"/#aboutmesection"} className="nav-link" onClick={closeMenu}>
                        Home
                    </HashLink>
                    <HashLink smooth to={"/#projects"} className="nav-link" onClick={closeMenu}>
                        Projects
                    </HashLink>
                    <HashLink smooth to={"/#contacts"} className="nav-link" onClick={closeMenu}>
                        Contact
                    </HashLink>
                    {userData && userData.role ==="admin" && (
                        <>
                            <Link to={"/messages"} className="nav-link" onClick={closeMenu}>
                                Messages
                            </Link>
                            <Link to={"/add_project"} className="nav-link" onClick={closeMenu}>
                                Add Project
                            </Link>
                        </>
                    )}
                </nav>

                <div className="nav-cta">
                    <button 
                        className={`theme-toggle ${theme === "dark" ? "theme-dark" : "theme-light"}`}
                        onClick={toggleTheme}
                        aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
                        title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
                    >
                        {theme === "dark" ? (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="5"></circle>
                                <line x1="12" y1="1" x2="12" y2="3"></line>
                                <line x1="12" y1="21" x2="12" y2="23"></line>
                                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                                <line x1="1" y1="12" x2="3" y2="12"></line>
                                <line x1="21" y1="12" x2="23" y2="12"></line>
                                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                            </svg>
                        ) : (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                            </svg>
                        )}
                    </button>
                    {userData ? (
                        <>
                            <p className="nav-user">Hi, {userData?.full_name?.split(" ")[0] || "Admin"}</p>
                            <button className="btn btn-ghost" onClick={LogOut}>Log out</button>
                        </>
                    ) : (
                        <Link to={"/signin"} className="btn btn-accent" onClick={closeMenu}>
                            Sign in
                        </Link>
                    )}
                </div>
            </div>
        </header>
    )
}

export default Navbar